var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { getDependencyByIndex, IdentifierUndefinedError, setDependency, } from './decorators';
import { prettyPrintIdentifier } from './dependencyItem';
import { RediError } from './error';
import { Quantity } from './types';
function mapQuantityToNumber(quantity) {
    switch (quantity) {
        case Quantity.OPTIONAL:
            return '0 or 1';
        case Quantity.REQUIRED:
            return '1';
        case Quantity.MANY:
            return '0 or more';
    }
}
var QuantityCheckError = /** @class */ (function (_super) {
    __extends(QuantityCheckError, _super);
    function QuantityCheckError(id, quantity, actual) {
        var _this = this;
        var msg = "Expect ".concat(mapQuantityToNumber(quantity), " dependency item(s) for id \"").concat(prettyPrintIdentifier(id), "\" but get ").concat(actual, ".");
        if (actual === 0) {
            msg += ' Did you forget to register it?';
        }
        if (actual > 1) {
            msg += ' You register it more than once.';
        }
        _this = _super.call(this, msg) || this;
        _this.quantity = quantity;
        _this.actual = actual;
        return _this;
    }
    return QuantityCheckError;
}(RediError));
export { QuantityCheckError };
export function checkQuantity(id, quantity, length) {
    if ((quantity === Quantity.OPTIONAL && length > 1)
        || (quantity === Quantity.REQUIRED && length !== 1)) {
        throw new QuantityCheckError(id, quantity, length);
    }
}
export function retrieveQuantity(quantity, arr) {
    if (quantity === Quantity.MANY) {
        return arr;
    }
    else {
        return arr[0];
    }
}
function changeQuantity(target, index, quantity) {
    var descriptor = getDependencyByIndex(target, index);
    descriptor.quantity = quantity;
}
function quantifyDecoratorFactoryProducer(quantity) {
    return function decoratorFactory(id) {
        if (this instanceof decoratorFactory) {
            return this;
        }
        return function (registerTarget, _key, index) {
            if (id) {
                setDependency(registerTarget, id, index, quantity);
            }
            else {
                if (quantity === Quantity.REQUIRED) {
                    throw new IdentifierUndefinedError(registerTarget, index);
                }
                changeQuantity(registerTarget, index, quantity);
            }
        };
    };
}
export var Many = quantifyDecoratorFactoryProducer(Quantity.MANY);
export var Optional = quantifyDecoratorFactoryProducer(Quantity.OPTIONAL);
export var Inject = quantifyDecoratorFactoryProducer(Quantity.REQUIRED);
//# sourceMappingURL=dependencyQuantity.js.map